import { Component, Input } from '@angular/core';
import { NewRoofCostZipFormComponent } from '../new-roof-cost-zip-form/new-roof-cost-zip-form.component';

@Component({
  selector: 'app-new-roof-cost-promo-banner',
  standalone: true,
  imports: [NewRoofCostZipFormComponent],
  templateUrl: './new-roof-cost-promo-banner.component.html',
  styleUrl: './new-roof-cost-promo-banner.component.scss',
})
export class NewRoofCostPromoBannerComponent {
  @Input() fetchedZipcode = '';
  heading = 'Free Roofing Estimates From Trusted Local Contractors';
}
